import { post } from '../../helpers/axiosWrapper';

export const deleteCacheByKey = (key: string, context: any): Promise<Common.IResult<any>> => {
  return post(`${process.env.REACT_APP_API_URL}/core/redis/delete-cache/${key}`, undefined, context);
};
